import React from 'react';

import svg from './assets/icons-24-info-circular.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const IconInfoCircular = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-info-circular" />
);
